import { useAtomValue } from "jotai";

import {
  toolsExperienceAtom,
  toolsExperienceOptionViewsAtom,
  projectTypeAtom,
  offeredGratificationAtom,
  forGratificationAtom,
  requiredAreaOfExpertiseAtom,
  projectDeadlineAtom,
  hardSkillsAtom,
  offeredWorkingTypeAtomNewArray,
  offeredWorkingTypeActiveOptionsAtom,
  usedLanguagesAtom,
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  requiredAvailabilityAtomStartValue,
  requiredAvailabilityAtomEndValue,
  requiredAvailabilityAtomOption,
  softSkillsAtom,
  locationsAtom,
} from "../components/ProjectFilters/atom/ProjectFiltersAtom";

interface reqBody {
  softSkills?: string[];
  areaOfExpertise?: string[];
  toolsExperience?: any;
  hardSkills?: string[];
  // projectBranch?: string[];
  offeredGratification?: string[];
  forGratification?: string[];
  projectType?: string[];
  deadline?: Date;
  bizRole?: number;
  techRole?: number;
  availabilityFrom?: number;
  availabilityTo?: number;
  availabilityType?: string;
  workingTypeOffice?: boolean;
  workingTypeRemote?: boolean;
  usedLanguages?: string[];
  description?: string;
  locations?: string[];
}

const useDataFromProjectFilters = () => {
  const toolsExperience = useAtomValue<string[]>(toolsExperienceAtom);
  const toolsExperienceOptionViews = useAtomValue(
    toolsExperienceOptionViewsAtom,
  );
  const projectType = useAtomValue<string[]>(projectTypeAtom);
  const offeredGratification = useAtomValue<string[]>(offeredGratificationAtom);
  const softSkills = useAtomValue<string[]>(
    softSkillsAtom
  );
  const requiredAreaOfExpertise = useAtomValue<string[]>(
    requiredAreaOfExpertiseAtom,
  );
  const forGratification = useAtomValue<string[]>(forGratificationAtom);
  const projectDeadline = useAtomValue(projectDeadlineAtom);
  const hardSkills = useAtomValue<string[]>(hardSkillsAtom);
  const offeredWorkingTypeActiveOptions = useAtomValue<boolean[]>(
    offeredWorkingTypeActiveOptionsAtom,
  );
  const usedLanguages = useAtomValue<string[]>(usedLanguagesAtom);
  const bizOrTechRoleLeftValue = useAtomValue(bizOrTechRoleAtomLeftValue);
  const bizOrTechRoleRightValue = useAtomValue(bizOrTechRoleAtomRightValue);
  const requiredAvailabilityStartValue = useAtomValue(
    requiredAvailabilityAtomStartValue,
  );
  const requiredAvailabilityEndValue = useAtomValue(
    requiredAvailabilityAtomEndValue,
  );
  const requiredAvailabilityOption = useAtomValue(
    requiredAvailabilityAtomOption,
  );
  const locations = useAtomValue(locationsAtom);

  let body: reqBody = {};
  body.softSkills = softSkills;
  body.toolsExperience = [];
  body.projectType = projectType;
  body.offeredGratification = offeredGratification;
  body.forGratification = forGratification;
  body.areaOfExpertise = requiredAreaOfExpertise;
  body.deadline = projectDeadline;
  body.hardSkills = hardSkills;
  body.workingTypeRemote = offeredWorkingTypeActiveOptions[0];
  body.workingTypeOffice = offeredWorkingTypeActiveOptions[1];
  body.usedLanguages = usedLanguages;
  body.bizRole =
    bizOrTechRoleLeftValue == "" ? 0 : parseInt(bizOrTechRoleLeftValue);
  body.techRole =
    bizOrTechRoleRightValue == "" ? 0 : parseInt(bizOrTechRoleRightValue);
  body.availability = requiredAvailabilityStartValue;
  delete body.availabilityFrom;
  delete body.availabilityTo;
  delete body.availabilityType;
  body.locations = locations;

  const keys = Object.keys(body);
  for (const key of keys) {
    if (!body[key as keyof reqBody]) {
      delete body[key as keyof reqBody];
    }
  } // is array empty we can do sth like that

  for (const tool of toolsExperience) {
    body.toolsExperience.push({
      tool: tool,
      mep: toolsExperienceOptionViews[tool],
    });
  }

  let stringToReturn = "";

  for (const key of Object.keys(body)) {
    if (key == "toolsExperience" && body[key as keyof reqBody].length) {
      stringToReturn += key + "=" + JSON.stringify(body[key as keyof reqBody]);
      stringToReturn += "&";
    } else if (
      Array.isArray(body[key as keyof reqBody]) &&
      body[key as keyof reqBody].length
    ) {
      stringToReturn += key + "=" + JSON.stringify(body[key as keyof reqBody]);
      // for(const element of body[key as keyof(reqBody)]){
      //     stringToReturn+=element+",";
      // }
      stringToReturn += "&";
    } else {
      if (
        typeof body[key as keyof reqBody] == "string" &&
        body[key as keyof reqBody] != ""
      ) {
        stringToReturn += key + "=" + body[key as keyof reqBody];
        stringToReturn += "&";
      } else if (
        typeof body[key as keyof reqBody] != "string" &&
        !Array.isArray(body[key as keyof reqBody])
      ) {
        switch (typeof body[key as keyof reqBody]) {
          case "object": {
            // date
            if (
              new Date(body[key as keyof reqBody]).getTime() !=
              new Date(0).getTime()
            ) {
              stringToReturn +=
                key + "=" + new Date(body[key as keyof reqBody]).toISOString();
              stringToReturn += "&";
            }
            break;
          }
          case "number": {
            if (body[key as keyof reqBody]) {
              stringToReturn += key + "=" + body[key as keyof reqBody];
              stringToReturn += "&";
            }
            break;
          }
          case "boolean": {
            if (body[key as keyof reqBody]) {
              stringToReturn += key + "=" + body[key as keyof reqBody];
              stringToReturn += "&";
            }
            break;
          }
        }
      }
    }
  }
  console.log("[useDataFromProjectFilters] stringToReturn:", stringToReturn);
  return stringToReturn;
};

export { useDataFromProjectFilters };
